<div class="container passes-page">
    <div class="passes-header">
        <h1 class="title-passes">Abonos disponibles</h1>
        <div class="filters-row d-flex align-items-center" style="gap: 16px;">
            <div class="buscador-event container-form d-flex align-items-center">
                <i class="fal fa-search search-icon"></i>
                <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar abono"
                    [ngModel]="searchText" (input)="onSearch(searchInput.value)">
            </div>
            <mat-form-field appearance="fill" class="filter-select">
                <mat-select placeholder="Tipo de descuento" [(ngModel)]="discountTypeFilter"
                    (selectionChange)="onFilterChange()">
                    <mat-option value="">Todos</mat-option>
                    <mat-option value="percentage">Porcentaje</mat-option>
                    <mat-option value="amount">Importe fijo</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <div class="passes-grid" *ngIf="loaded && passes.length > 0">
        <div class="pass-card" *ngFor="let pass of passes" (click)="openPass(pass)">
            <div class="pass-card-body">
                <h3 class="pass-name">{{ pass.name }}</h3>
                <div class="pass-discount-badge">
                    <i class="fa-light fa-tag"></i>
                    <span>{{ getDiscountLabel(pass) }}</span>
                </div>
                <div class="pass-events-count" *ngIf="getEventCount(pass) > 0">
                    <i class="fa-light fa-calendar"></i>
                    <span>{{ getEventCount(pass) }} evento{{ getEventCount(pass) !== 1 ? 's' : '' }}</span>
                </div>
            </div>
            <div class="pass-card-footer">
                <button class="primary-button solid btn-detail">Ver detalle</button>
            </div>
        </div>
    </div>

    <div class="empty-state" *ngIf="loaded && passes.length === 0">
        <i class="fa-light fa-ticket fa-3x" style="color: #ccc;"></i>
        <p>No hay abonos disponibles en este momento</p>
    </div>
</div>
